import { csvImportApi } from '@/services/csvImportApi'

const state = {
  file: null,
  loading: false,
  previewing: false,
  importing: false,
  previewResult: null,
  importResult: null,
  history: [],
  historyLoading: false,
  error: null,
  step: 'upload',
}

const getters = {
  file: (state) => state.file,
  loading: (state) => state.loading,
  previewing: (state) => state.previewing,
  importing: (state) => state.importing,
  previewResult: (state) => state.previewResult,
  importResult: (state) => state.importResult,
  history: (state) => state.history,
  historyLoading: (state) => state.historyLoading,
  error: (state) => state.error,
  step: (state) => state.step,
  hasErrors: (state) => state.previewResult?.data?.errors?.length > 0,
  errorCount: (state) => state.previewResult?.data?.errors?.length || 0,
  totalRows: (state) => state.previewResult?.data?.total_rows || 0,
  canImport: (state) => state.previewResult?.success === true && !state.importing,
  isCompleted: (state) => state.importResult?.success === true,
}

const mutations = {
  SET_FILE(state, file) {
    state.file = file
    state.previewResult = null
    state.importResult = null
    state.error = null
    state.step = 'upload'
  },
  CLEAR_FILE(state) {
    state.file = null
    state.previewResult = null
    state.importResult = null
    state.error = null
    state.step = 'upload'
  },
  SET_PREVIEWING(state, val) {
    state.previewing = val
  },
  SET_IMPORTING(state, val) {
    state.importing = val
  },
  SET_PREVIEW_RESULT(state, result) {
    state.previewResult = result
  },
  SET_IMPORT_RESULT(state, result) {
    state.importResult = result
  },
  SET_HISTORY(state, items) {
    state.history = items
  },
  SET_HISTORY_LOADING(state, val) {
    state.historyLoading = val
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_STEP(state, step) {
    state.step = step
  },
  RESET_TO_UPLOAD(state) {
    state.file = null
    state.previewResult = null
    state.importResult = null
    state.error = null
    state.step = 'upload'
  },
}

const actions = {
  setFile({ commit }, file) {
    commit('SET_FILE', file)
  },
  clearFile({ commit }) {
    commit('CLEAR_FILE')
  },
  async previewFile({ commit, state, getters }) {
    if (!state.file) {
      commit('SET_ERROR', 'Debes seleccionar un archivo primero.')
      return { success: false }
    }

    commit('SET_PREVIEWING', true)
    commit('SET_ERROR', null)
    commit('SET_PREVIEW_RESULT', null)

    try {
      const response = await csvImportApi.preview(state.file)
      commit('SET_PREVIEW_RESULT', response)
      commit('SET_STEP', getters.hasErrors ? 'errors' : 'preview')
      return { success: response.success, data: response.data }
    } catch (error) {
      if (error.data) {
        commit('SET_PREVIEW_RESULT', error.data)
      }
      commit('SET_ERROR', error.message || 'Error al procesar el archivo.')
      commit('SET_STEP', getters.hasErrors ? 'errors' : 'preview')
      return { success: false, error: state.error }
    } finally {
      commit('SET_PREVIEWING', false)
    }
  },
  async importFile({ commit, state }) {
    if (!state.file) {
      commit('SET_ERROR', 'Debes seleccionar un archivo primero.')
      return { success: false }
    }

    commit('SET_IMPORTING', true)
    commit('SET_ERROR', null)
    commit('SET_IMPORT_RESULT', null)

    try {
      const response = await csvImportApi.import(state.file)
      commit('SET_IMPORT_RESULT', response)
      commit('SET_STEP', 'result')
      return { success: response.success, data: response.data }
    } catch (error) {
      if (error.data) {
        commit('SET_IMPORT_RESULT', error.data)
      }
      commit('SET_ERROR', error.message || 'Error al importar el archivo.')
      commit('SET_STEP', 'result')
      return { success: false, error: state.error }
    } finally {
      commit('SET_IMPORTING', false)
    }
  },
  async fetchHistory({ commit, dispatch }) {
    commit('SET_HISTORY_LOADING', true)
    try {
      const response = await csvImportApi.getHistory()
      commit('SET_HISTORY', response.data || [])
      return { success: true }
    } catch (error) {
      console.error('Error fetching import history:', error)
      return { success: false }
    } finally {
      commit('SET_HISTORY_LOADING', false)
    }
  },
  resetToUpload({ commit }) {
    commit('RESET_TO_UPLOAD')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
